import React from 'react';
import { Typography } from 'kangarootime-ui';

const Header = header => (
  <Typography type='meta' style={{ fontSize: 10 }}>{header.label.toUpperCase()}</Typography>
);

export default Header;
